export const CITY_COOKIE_TTL = 60 * 60 * 24 * 30;
export const COOKIE_DOMAIN = '.quikr.com';
export const ALL_INDIA = 'All India';
export const ALL_INDIA_CITY_ID = '1';
export const CITY_ID_COOKIE_KEY = 'prefer_city_id';
export const CITY_NAME_COOKIE_KEY = 'new_prefer_city';
export const RECENT_SEARCHES_KEY = 'recentSearches';
export const TRENDING_SEARCHES_KEY = 'trendingSearches';
export const ABRAND_COOKIE_KEY = 'abRand';
export const STATE_NAME_COOKIE_KEY = 'new_prefer_state';
export const STATE_ID_COOKIE_KEY = 'new_prefer_state_id';
export const WALLET_REDIRECTION_CONSTANT = 100;

/**** API ENDPOINTS START****/

export const DEFAULT_HOSTNAME = 'www.quikr.com';
export const HEADER_API_HOST = 'https://feservices.quikr.com/v2/header';
export const TRENDING_SEARCH_API_PATH = 'fetch_trending_searches';
export const GET_USER_API_PATH = 'core/base/sign-in/get-user';

/**** API ENDPOINTS END ****/

export const RECOMMENDATION_LOCAL_STORAGE_KEY = 'commonParamsForCrossCategory';
export const PLAY_STORE_REDIRECT_URL = {
    jobs: 'https://play.google.com/store/apps/details?id=com.quikr.job',
    others: 'https://play.google.com/store/apps/details?id=com.quikr'
};


// WEBPACK FOOTER //
// ../q-components/helpers/constants.js